import { IModelService, IRequestResult, IModelQuery } from '../schemas/structure';
import { IGroup } from '../schemas/entity_set';
import { AngularServices, AppServices } from '../helpers/config_keys';

interface IGroupQuery extends IModelQuery {
}

interface IGroupService extends IModelService<IGroup> {
    query(params: IGroupQuery): angular.IPromise<IRequestResult<Array<IGroup>>>
}

class GroupService implements IGroupService {

    static $inject = [AngularServices.Q, AngularServices.Http, AppServices.BaseApi];

    constructor(private $q: angular.IQService,
        private $http: angular.IHttpService,
        private baseUrl: string) { }

    get() {
        let defer = this.$q.defer<IRequestResult<Array<IGroup>>>()
        this.$http.get(`${this.baseUrl}/group`)
            .then((response: IRequestResult<Array<IGroup>>) => {
                defer.resolve(response);
            });
        return defer.promise;
    }

    find(id: number) {
        let defer = this.$q.defer<IRequestResult<IGroup>>();
        this.$http.get(`${this.baseUrl}/group?id=${id}`)
            .then((response: IRequestResult<IGroup>) => {
                defer.resolve(response);
            });
        return defer.promise;
    }

    query(params: IGroupQuery) {
        let defer = this.$q.defer<IRequestResult<Array<IGroup>>>();
        this.$http.post(`${this.baseUrl}/group/query`, params)
            .then((response: IRequestResult<Array<IGroup>>) => {
                defer.resolve(response);
            });
        return defer.promise;
    }

    save(group: IGroup) {
        let defer = this.$q.defer<IRequestResult<IGroup>>();
        if (group.id) {
            this.$http.put(`${this.baseUrl}/group`, group)
                .then((response: IRequestResult<IGroup>) => {
                    defer.resolve(response);
                });
        } else {
            this.$http.post(`${this.baseUrl}/group`, group)
                .then((response: IRequestResult<IGroup>) => {
                    defer.resolve(response);
                });
        }
        return defer.promise;
    }

    delete(id: number) {
        let defer = this.$q.defer<IRequestResult<IGroup>>();
        this.$http.delete(`${this.baseUrl}/group?id=${id}`)
            .then((response: IRequestResult<IGroup>) => {
                defer.resolve(response);
            });
        return defer.promise
    }
}

export { GroupService, IGroupService, IGroupQuery }


// WEBPACK FOOTER //
// ./app/address/group_service.ts